import React from 'react';
import { useTranslation } from 'react-i18next';
import GlobalStringSettingPage from './GlobalStringSettingPage';

interface GlobalProjectSettingsSignaturePageProps {
  className?: string;
}

export const GlobalProjectSettingsSignaturePage: React.FC<
  GlobalProjectSettingsSignaturePageProps
> = (props) => {
  const { t } = useTranslation();
  return (
    <GlobalStringSettingPage
      className={props.className}
      settingType="emailSignature"
      title={t('settings:projectSettingsTable.title.signature')}
    />
  );
};

export default GlobalProjectSettingsSignaturePage;
